import { useCallback } from 'react';
import { useBlocker } from 'react-router-dom';

import type { ConfirmOptions } from '@app/providers/NewConfirmProvider/NewConfirmProvider.types';
import { useConfirmNew } from '@app/providers/NewConfirmProvider/useConfirmNew';

interface PromptOptions extends ConfirmOptions {
  hasChanges: boolean;
}

export type ConfirmResult = 'confirm' | 'discard' | 'cancel';
export type UnsavedConfirmType = () => Promise<ConfirmResult>;

export const useNewUnsavedData = ({
  hasChanges = false,
  showDiscard = true,
  title = 'Есть несохранённые изменения!',
  message = 'В текущем разделе есть несохранённые данные. Хотите сохранить данные перед уходом?',
  confirmText = 'Сохранить',
  cancelText = 'Отмена',
  discardText,
  type = 'warning',
}: PromptOptions) => {
  const { show } = useConfirmNew();

  const confirm: UnsavedConfirmType = useCallback(() => {
    if (!hasChanges) {
      return Promise.resolve('confirm');
    }

    return new Promise<ConfirmResult>((resolve) => {
      show({
        title,
        message,
        confirmText,
        cancelText,
        discardText,
        type,
        showDiscard,
        onConfirm: () => resolve('confirm'),
        onCancel: () => resolve('cancel'),
        onDiscard: () => resolve('discard'),
        dataTestId: '',
      });
    });
  }, [
    hasChanges,
    show,
    title,
    message,
    confirmText,
    cancelText,
    discardText,
    showDiscard,
    type,
  ]);

  useBlocker(hasChanges);

  return { confirm };
};
